// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-options {\n  margin: 0px;\n  font-size: 8pt;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.feedback-options input[type=\"radio\"],\n.feedback-options input[type=\"checkbox\"] {\n  margin: 0.3em;\n}\n.feedback-options h3 {\n  color: #3f3f3f;\n  font-size: 1em;\n  margin: 0px;\n  margin-bottom: 0.25em;\n}\n", ""]);
// Exports
module.exports = exports;
